import React from "react";
import ReactDOM from "react-dom";
import App from "./router";

import "@/styles/global.scss";

ReactDOM.render(<App />, document.getElementById("root"));
